// Plan builder (Student Evaluation Planner tab): the student's plans, the plan on the board, its requirements, the
// planner settings, the undo history and the edit waiting on its consequences check.
export const PB_PLANS_REQUEST = 'DP_PB_PLANS_REQUEST';
export const PB_PLANS_SUCCESS = 'DP_PB_PLANS_SUCCESS';
export const PB_PLANS_FAILURE = 'DP_PB_PLANS_FAILURE';

export const PB_PLAN_REQUEST = 'DP_PB_PLAN_REQUEST';
export const PB_PLAN_SUCCESS = 'DP_PB_PLAN_SUCCESS';
export const PB_PLAN_FAILURE = 'DP_PB_PLAN_FAILURE';
export const PB_PLAN_CLEARED = 'DP_PB_PLAN_CLEARED';
/** The plan as it will be once a move or reorder lands, or as it was when one is refused. */
export const PB_PLAN_SHOWN = 'DP_PB_PLAN_SHOWN';

export const PB_REQUIREMENTS_REQUEST = 'DP_PB_REQUIREMENTS_REQUEST';
export const PB_REQUIREMENTS_SUCCESS = 'DP_PB_REQUIREMENTS_SUCCESS';
export const PB_REQUIREMENTS_FAILURE = 'DP_PB_REQUIREMENTS_FAILURE';

export const PB_SETTINGS_SUCCESS = 'DP_PB_SETTINGS_SUCCESS';

export const PB_SAVE_START = 'DP_PB_SAVE_START';
export const PB_SAVE_SUCCESS = 'DP_PB_SAVE_SUCCESS';
export const PB_SAVE_FAILURE = 'DP_PB_SAVE_FAILURE';
export const PB_ERROR_CLEAR = 'DP_PB_ERROR_CLEAR';

export const PB_PREVIEW_CHECKING = 'DP_PB_PREVIEW_CHECKING';
export const PB_EDIT_PENDING = 'DP_PB_EDIT_PENDING';
export const PB_CHAINING = 'DP_PB_CHAINING';
export const PB_ANNOUNCE = 'DP_PB_ANNOUNCE';

export const PB_UNDO_RECORD = 'DP_PB_UNDO_RECORD';
export const PB_UNDO_TRACK = 'DP_PB_UNDO_TRACK';
export const PB_UNDO_STEP_BACK = 'DP_PB_UNDO_STEP_BACK';
export const PB_UNDO_STEP_FORWARD = 'DP_PB_UNDO_STEP_FORWARD';
/** A refused undo or redo that had made part of its sequence: the entry keeps only the steps still to make. */
export const PB_UNDO_REMAINING = 'DP_PB_UNDO_REMAINING';

export const PB_RESET = 'DP_PB_RESET';

export const PB_VISIT_START = 'DP_PB_VISIT_START';
export const PB_VISIT_END = 'DP_PB_VISIT_END';
